import { CFTokens } from '../tokens';
import { hexWithOpacity } from '../utils';
const { COLOR: { BACKGROUND_DEFAULT, BACKGROUND_ALTERNATE, BORDER_DEFAULT, BORDER_ALTERNATE_DEFAULT, TEXT_AND_ELEMENT_ALTERNATE, TEXT_AND_ELEMENT_DEFAULT, }, } = CFTokens;
export const Default = {
    COLOR: {
        ICON: TEXT_AND_ELEMENT_DEFAULT,
        ICON_ALTERNATE: TEXT_AND_ELEMENT_ALTERNATE,
        MODAL_BACKGROUND: BACKGROUND_DEFAULT,
        MODAL_BACKGROUND_ALTERNATE: BACKGROUND_ALTERNATE,
        MODAL_DIVIDER: BORDER_DEFAULT,
        MODAL_DIVIDER_ALTERNATE: BORDER_ALTERNATE_DEFAULT,
        MODAL_VEIL: hexWithOpacity(BACKGROUND_ALTERNATE, 0.6),
        MODAL_VEIL_ALTERNATE: hexWithOpacity(BACKGROUND_DEFAULT, 0.6),
        TEXT: TEXT_AND_ELEMENT_DEFAULT,
        TEXT_ALTERNATE: TEXT_AND_ELEMENT_ALTERNATE,
    },
    NAME: 'default',
};
